module.exports = __webpack_public_path__ + "static/environment-e1d3a7da6a9d25837d7fae16b31cd545.svg";